import * as React from 'react';
import { Component } from 'react';

import './OpenedCountriesHomeView.scss';
import i18next from 'i18next';

const checkedIcon = require('../../assets/checkbox_selected.svg');
const noCheckedIcon = require('../../assets/check_box_empty_gray.svg');

interface CovidHomeViewProps {
    filters: Array<string>;
    setFilters: (key: string) => any;
}

interface CovidHomeViewState {
    regions: Array<{key: string, name: string}>;
}

export default class OpenedCountriesHomeView extends Component<CovidHomeViewProps, CovidHomeViewState> {

    state = {
        regions: [
            {
                key: 'sea',
                name: i18next.t('sea')
            },
            {
                key: 'mountains',
                name: i18next.t('mountains')
            },
            {
                key: 'europe',
                name: i18next.t('europe')
            },
            {
                key: 'asia',
                name: i18next.t('asia')
            },
            {
                key: 'africa',
                name: i18next.t('africa')
            },
            {
                key: 'south_america',
                name: i18next.t('south_america')
            },
            {
                key: 'near_east',
                name: i18next.t('near_east')
            },
            {
                key: 'north_america',
                name: i18next.t('north_america')
            },
            {
                key: 'cis',
                name: i18next.t('cis')
            }
        ],
        entries: [
            {
                key: 'for_vaccinated',
                name: i18next.t('for_vaccinated')
            },
            {
                key: 'no_quarantine',
                name: i18next.t('no_quarantine')
            },
            {
                key: 'for_who_have_been_ill',
                name: i18next.t('for_who_have_been_ill')
            },
            {
                key: 'without_pcr',
                name: i18next.t('without_pcr')
            }
        ]
    };

    render() {
        const { regions, entries } = this.state;
        const { filters, setFilters } = this.props;
        const visa = !!filters.find(r => r === 'visa');
        return (
            <div className='regions'>
                <div className='regions__subtitle'>
                    {i18next.t('where_do_you_want_to_go')}
                </div>
                <div className='regions__menu'>
                    {regions.map((region, i) =>
                            <div
                                key={i}
                                className={`button ${!!filters.find(r => r === region.key) ? 'active' : ''}`}
                                onClick={() => setFilters(region.key)}
                            >
                                {region.name}
                            </div>
                        )}
                </div>
                <div className='regions__subtitle'>
                    {i18next.t('visa')}
                </div>
                <div className='tabs' style={{border: 'none'}}>
                    <div className='tabs-wrapper' style={{padding: 1}}>
                        <div
                            className={`tab-item left ${visa ? 'active' : ''}`}
                            onClick={() => !visa && setFilters('no_visa')}
                        >
                            {i18next.t('yes')}
                        </div>

                        <div
                            className={`tab-item right ${!visa ? 'active' : ''}`}
                            onClick={() => visa && setFilters('visa')}
                        >
                            {i18next.t('no')}
                        </div>
                    </div>
                </div>
                <div className='regions__subtitle' style={{marginTop: 54}}>
                    {i18next.t('entry')}
                </div>
                <div className='regions__menu'>
                    {entries.map((entry, i) =>
                        <div
                            key={i}
                            className={`button ${!!filters.find(r => r === entry.key) ? 'active' : ''}`}
                            onClick={() => setFilters(entry.key)}
                        >
                            {entry.name}
                        </div>
                    )}
                </div>
                <div className={`regions__flag`} onClick={() => setFilters('direct')}>
                    <img src={!!filters.find(r => r === 'direct') ? checkedIcon : noCheckedIcon} className='checkbox' />
                    <div className='option-label'>
                        {i18next.t('no_transfers')}
                    </div>
                </div>
                <div className={`regions__flag`} onClick={() => setFilters('no_int_passport')}>
                    <img src={!!filters.find(r => r === 'no_int_passport') ? checkedIcon : noCheckedIcon} className='checkbox' />
                    <div className='option-label'>
                        {i18next.t('no_int_passport')}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/OpenedCountries/OpenedCountriesHomeView.tsx